// neo_cogym — 진도 보고 클라이언트 (P1)
// PDF/VIDEO 진도를 Workers /api/progress 로 전송. 잦은 호출은 디바운스.

import type { ProgressUpdate } from "./types";
import { API_BASE } from "../api/client";

export interface ProgressReporterOptions {
  endpoint?: string; // 기본 {API_BASE}/api/progress
  debounceMs?: number;
  getAuthToken?: () => string | null;
}

export function createProgressReporter(opts: ProgressReporterOptions = {}) {
  const endpoint = opts.endpoint ?? `${API_BASE}/api/progress`;
  const debounceMs = opts.debounceMs ?? 1500;
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending: ProgressUpdate | null = null;

  async function flush() {
    if (!pending) return;
    const body = JSON.stringify(pending);
    pending = null;
    const token = opts.getAuthToken?.();
    try {
      await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body,
        keepalive: true, // 페이지 이탈 시에도 전송
      });
    } catch {
      /* 오프라인 등 — 다음 보고에서 최신값으로 재전송 */
    }
  }

  return {
    report(p: ProgressUpdate) {
      pending = { ...pending, ...p };
      if (timer) clearTimeout(timer);
      timer = setTimeout(flush, debounceMs);
    },
    flushNow: flush,
  };
}
